/*
Controller: FoundryHealth

Operations:
  getFoundryHealthChallenges
*/
var Api = require('../config')

var FoundryHealth = (function () {
  /*
  Operation: getFoundryHealthChallenges
  Get foundry health challenges and status
  Parameters:
    foundryId: Id of the foundry
  Responses:
    HTTP 200: Collection of FoundryHealthChallenges and status
    HTTP 403: Operation not permitted
  */
  function getFoundryHealthChallengesFoundryHealth (foundryId) {
    return new Promise(function (resolve, reject) {
      try {
        if (!foundryId) {
          throw new Error('foundryId: Missing parameter')
        }
        if (foundryId && !(typeof foundryId === 'string')) {
          throw new Error('foundryId: Wrong type: Got "' + (typeof foundryId) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      var path = '/foundryHealth/status/{foundryId}'
      path = path.replace('{' + 'foundryId' + '}', foundryId)
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  var ret = {}
  ret['getFoundryHealthChallenges'] = getFoundryHealthChallengesFoundryHealth
  return ret
})()

module.exports = FoundryHealth
